import moment from 'moment';
import Api from '../Api';
import { parseUnits, formatHash } from '../utils';

export default class MinerLastBlockAndSubmits {
    constructor(divToAppend, wallet, coin = 'bch') {
        this.coin = coin;
        this.wallet = wallet;
        this.container = divToAppend;
        this.tab = 'submits';

        divToAppend.innerHTML = `
        <div class="card">
            <div class="card-header">
                <ul class="nav nav-pills card-header-pills">
                    <li class="nav-item">
                        <a class="nav-link submits active" href="#">Last submits</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link blocks" href="#">Last blocks</a>
                    </li>
                </ul>
            </div>
            <div class="card-table table-responsive">
                <div class="progress progress-sm">
                    <div class="progress-bar progress-bar-indeterminate"></div>
                </div>
            </div>
        </div>`;

        divToAppend.querySelector('a.submits').addEventListener('click', (e) => {
            e.preventDefault();
            this.tab = 'submits';
            this.updateNavPills();
            this.renderSubmits();
        });

        divToAppend.querySelector('a.blocks').addEventListener('click', (e) => {
            e.preventDefault();
            this.tab = 'blocks';
            this.updateNavPills();
            this.fetchBlocks().then(r => {
                this.renderBlocks();
            });
        });

        this.fetchSubmits().then(r => {
            this.renderSubmits();
        });

        setInterval(() => {
            if (this.tab == 'submits') {
                this.fetchSubmits().then(r => {
                    this.renderSubmits();
                });
            } else {
                this.fetchBlocks().then(r => {
                    this.renderBlocks();
                });
            }
        }, 15 * 1000);
    }

    updateNavPills() {
        this.container.querySelectorAll('.nav-pills a').forEach(element => {
            if (element.classList.contains(this.tab)) element.classList.add('active');
            else element.classList.remove('active');
        });
    }

    renderBlocks() {
        let rows = '';
        for (const block of this.blocks) {
            let icon = '/images/coin_icons/' + block.coin + '.png';

            let luckRow = `<td class="text-secondary>...</td>`;
            if (block.luck) luckRow = `<td class="text-secondary ${block.luck > 1 ? 'text-red' : 'text-green'}">${ Math.round(block.luck * 100) }%</td>`;

            let mul = 100000000;
            if (block.coin == 'xec') mul = 100;
            let blockReward = Math.round(block.coinbasevalue / mul * 100) / 100;

            let explorerLink = `https://explorer.bitcoinunlimited.info/block-height/${block.height}`;
            if (block.coin == 'xec') explorerLink = `https://explorer.e.cash/block-height/${block.height}`;
            if (block.coin == 'dgb') explorerLink = `https://chainz.cryptoid.info/dgb/block.dws?${block.height}.htm`;
            if (block.coin == 'rvn') explorerLink = `https://rvn.tokenview.io/en/block/${block.height}`;
            rows += `
            <tr>
                <td>
                    <img src="${icon}" class="icon" alt="icon" />
                    ${block.isOrphan ? 
                        ('<span class="text-muted">' + block.height + ' (<span class="text-red">Orphan block</span>)</span>') :
                        ('<a href="'+ explorerLink +'" target="_blank">' + block.height + '</a>')  }
                </td>
                <td class="text-secondary">${ moment(block.at).format("DD.MM.YYYY, HH:mm:ss") }</td>
                <td class="text-secondary">${ block.rig }</td>
                <td class="text-secondary">${ parseUnits(block.diff, '')}</td>
                <td class="text-secondary">
                    <span class="text-green small">${ blockReward }${block.coin.toUpperCase()}<br/>~$${ block.fiatValue }</span>
                ${luckRow}
            </tr>`;
        }

        this.container.querySelector('.card-table').innerHTML = `
        <table class="table table-vcenter">
            <thead>
                <tr>
                    <th>Block height</th>
                    <th>Found at</th>
                    <th>Rig</th>
                    <th>Share diff</th>
                    <th>Block reward</th>
                    <th>Luck</th>
                </tr>
            </thead>
            <tbody>${rows}</tbody>
        </table>`;
    }

    renderSubmits() {
        let rows = '';
        for (const submit of this.submits) {
            rows += `
            <tr>
                <td>${ submit.rig }</td>
                <td>${ parseUnits(Math.round(submit.shareDiff*100)/100, '') }</td>
                <td><kbd>${ formatHash(submit.hash.data, '').substring(0, 32) } ...</kbd></td>
                <td>${ moment(submit.at).format("HH:mm:ss") }</td>
            </tr>`;
        }

        this.container.querySelector('.card-table').innerHTML = `
        <table class="table">
            <thead>
                <tr>
                    <th>RIG</th>
                    <th>Share diff</th>
                    <th>Hash</th>
                    <th>Submited</th>
                </tr>
            </thead>
            <tbody>${rows}</tbody>
        </table>`;
    }

    async fetchSubmits() {
        this.isLoading = true;
        try {
            this.submits = await Api.miner.submits(this.coin, this.wallet);
        } catch (error) {
            console.warn("Cant load submits");
        }
        this.isLoading = false;
    }

    async fetchBlocks() {
        this.isLoading = true;
        try {
            this.blocks = await Api.miner.blocks(this.coin, this.wallet);
        } catch (error) {
            console.warn("Cant load blocks");
        }
        this.isLoading = false;
    }
}